import PropTypes from 'prop-types';
import React from 'react';

import {NO_WATERMARKING_CONFIG_FOR_EVENT_CONTENT} from '@constants/messages';
import {Alert} from '@ui';

const EventWatermarkingMissingConfigBanner = ({missingConfigLabels}) => {
    if (!missingConfigLabels?.length) {
        return null;
    }

    return (
        <>
            {missingConfigLabels.map((label) => (
                <Alert key={label} className='--marginBottom-10' icon={false} severity='warning'>
                    {NO_WATERMARKING_CONFIG_FOR_EVENT_CONTENT(label)}
                </Alert>
            ))}
        </>
    );
};

EventWatermarkingMissingConfigBanner.propTypes = {
    missingConfigLabels: PropTypes.arrayOf(PropTypes.string),
};

EventWatermarkingMissingConfigBanner.defaultProps = {
    missingConfigLabels: [],
};

export default EventWatermarkingMissingConfigBanner;
